// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-icon:hover {
  transform: scale(1.3);
}

.template-name:hover {
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/Email/EmailComponent.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAGA;EACI,sBAAA;AAAJ","sourcesContent":[".more-icon:hover{\n    transform: scale(1.3);\n    // transition: 0.3s;\n}\n\n.template-name:hover{\n    transform: scale(1.05);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
